import React, { useEffect, useState } from "react";
import Card from "components/card";
import { Form, Input, DatePicker, Space, Select } from 'antd';
import dayjs from 'dayjs';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getUserDetails, doUserCreate, doUserUpdate 
} from "../../../../redux/adminuser/adminUserState";
import { useForm } from 'antd/lib/form/Form';
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from '../../../../utils/crudSagaHelper';
import { DATE_FORMAT } from '../../../../variables/constants';
import RegionProvinceBarangay from "components/fields/RegionProvinceBarangay";
import { FormatDateValue } from "../../../../utils/index";
import { QRCodeCanvas } from 'qrcode.react';

const dateFormat = 'YYYY-MM-DD';

const UserForm = ({getRecord, doCreate, doUpdate, recordData, requesting, success, errors, regions, provinces, municipalities, barangays, ...props}) => {
	
  	const { recordId, mode } = props;  	
  	const [form] = useForm();
  	
  	useEffect(() => {
        getRecord(recordId);
	}, [recordId, getRecord]);
	
	useEffect(() => {
		if(recordData){
			
			const { user_details, type, ...restData } = recordData;
	        const initialValues = {
				...user_details,
				...type,
				...restData,
	        };

	        form.setFieldsValue(initialValues);
        }
    }, [recordData, form]);
    
  	const onSubmit = (formData) => {	
    	try {  
			
			formData.type_id = 2;
			recordData.id > 0 ? doUpdate(formData): doCreate(formData); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Card extra={"w-full h-full p-4"}>
		  	<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
		  		layout="vertical"
		  		onFinish={onSubmit}
	        >   
	        	<FormItem
			        name="id"
			        hidden
			    >
			        <Input type="hidden"/>
			    </FormItem>
				<FormItem
			        name="type_id"
			        hidden
			    >
			        <Input type="hidden"/>
			    </FormItem>
				<div className="grid grid-cols-4">
					<FormItem 
						name="account_id"
						label="Province / DA Account"
						rules={[requiredField()]}
					>
						{mode === 'edit' ?
						<Select id="account_id"
							showSearch
							allowClear={true}
							options={recordData?.accountOptions}
						/>													
						: <label className="ps-3 dark:text-white">{recordData?.account?.name}</label>
						}
					</FormItem>
					<FormItem 
						name="username"
						label="Username"
						rules={[requiredField()]}
					>
						{mode === 'edit' ?
						<Input id="username"
							maxLength={100}	
						/>
						: <label className="ps-3 dark:text-white">{recordData?.username}</label>
						}	                
					</FormItem>
				</div>
					
				<div className="grid grid-cols-4">
					<FormItem 
						name="last_name"
						label="Last Name"
						rules={[requiredField()]}
					>
						{mode === 'edit' ?
						<Input id="last_name"
							maxLength={50}		            		
							/> 
						: <label className="ps-3 dark:text-white">{recordData?.user_details?.last_name}</label>
						}           
					</FormItem>        
					<FormItem 
						name="first_name"
						label="First Name"
						rules={[requiredField()]}
					>
						{mode === 'edit' ?
						<Input id="first_name"
						maxLength={50}		            		
						/>
						: <label className="ps-3 dark:text-white">{recordData?.user_details?.first_name}</label>
						}  
					</FormItem>
					<FormItem 
						name="middle_name"
						label="Middle Name"
						rules={[requiredField()]}
					>
						{mode === 'edit' ?
						<Input id="middle_name"
						maxLength={50}		            		
						/>
						: <label className="ps-3 dark:text-white">{recordData?.user_details?.middle_name}</label>
						}  
					</FormItem>
					<FormItem 
						name="suffix"
						label="Extension Name"					
					>
						{mode === 'edit' ?
						<Input id="suffix"
						maxLength={20}		            		
						/>
						: <label className="ps-3 dark:text-white">{recordData?.user_details?.suffix}</label>
						}  
					</FormItem>									            	            		            	 
					
				</div>

				{(mode === 'edit') &&
				<>
					<div className="my-5">
						<label className="form-section-label">PASSWORD</label>
					</div>				
					<div className="grid grid-cols-4">				
						<FormItem 
							name="password"
							label="New Password"
							rules={[...(recordId ? [] : [requiredField()]),
								() => ({
									validator(_, value) {
										if (!value) {
											return Promise.resolve();
										}
										const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d\W_]{8,}$/;
										if (!regex.test(value)) {
											return Promise.reject(new Error("Password must be of 8 characters with at least one uppercase, one lowercase, and a number"));
										}
										return Promise.resolve();
									},
								}),
							]}
						>
							<Input id="password"
								type="password"
								maxLength={100}
							/>						
						</FormItem>
						<FormItem 
							name="password_confirmation"
							label="Confirm Password"
							rules={[...(recordId ? [] : [requiredField()]),
								({ getFieldValue }) => ({
									validator(_, value) {
										if (!value) {
											return Promise.resolve();
										}									
										const password = getFieldValue('password');					
										if (value !== password) {
											return Promise.reject(new Error(`Confirm password doesn't match`));
										}
										return Promise.resolve();
									},
								}),
							]}
						>
							<Input id="password_confirmation"
								type="password"
								maxLength={100}
							/>
						</FormItem>	
					</div>
				</>
				}
	 			<CrudButtons baseRoute="/console/admin-users" mode={mode} recordId={recordId} /> 				 			
	 		</Form>	 	
	 	</Card>
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.adminUser.userDetails?.data,
  	requesting: state.adminUser.userDetails?.requesting,
  	success: state.adminUser.userDetails?.success,
	regions: state.psgcData.regions?.items,
	provinces: state.psgcData.provinces?.items,
	municipalities: state.psgcData.municipalities?.items,
	barangays: state.psgcData.barangays?.items,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getUserDetails(id)),
  	doCreate: (data) => dispatch(doUserCreate(data)),
  	doUpdate: (data) => dispatch(doUserUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserForm);
